(function () {
  'use strict';

  const observedRows = new WeakSet();
  const rowObserver = typeof ResizeObserver === 'undefined'
    ? null
    : new ResizeObserver((entries) => {
      entries.forEach(({ target }) => updateRowAlignment(target));
    });

  function updateRowAlignment(row) {
    if (!row) return;
    const price = row.querySelector('.bsb-plpc__price');
    const rowRight = row.querySelector('.bsb-plpc__row-right');
    if (!price || !rowRight) return;
    row.classList.remove('is-wrapped');
    row.classList.toggle('is-wrapped', rowRight.offsetTop > price.offsetTop);
  }

  function initializeRowAlignment() {
    document.querySelectorAll('.bsb-plpc__row').forEach((row) => {
      updateRowAlignment(row);
      if (rowObserver && !observedRows.has(row)) {
        observedRows.add(row);
        rowObserver.observe(row);
      }
    });
  }

  window.bsbRefreshPlpCardRows = initializeRowAlignment;
  initializeRowAlignment();

  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.bsb-plpc__swatch');
    if (!swatch) return;

    const card = swatch.closest('.bsb-plpc');
    if (!card) return;

    card.querySelectorAll('.bsb-plpc__swatch').forEach((btn) => {
      btn.classList.toggle('bsb-plpc__swatch--active', btn === swatch);
      btn.setAttribute('aria-pressed', String(btn === swatch));
    });

    const url = swatch.getAttribute('data-variant-url');
    if (url) {
      card.querySelectorAll('.bsb-plpc__variant-link').forEach((link) => {
        link.setAttribute('href', url);
      });
    }

    const heart = card.querySelector('joy-wishlist-button');
    if (heart && swatch.dataset.variantId) heart.setAttribute('variant-id', swatch.dataset.variantId);

    const price = parseInt(swatch.getAttribute('data-price'), 10);
    const priceEl = card.querySelector('.bsb-plpc__price .bsb-price');
    if (Number.isFinite(price) && priceEl && window.bsbPrice) {
      window.bsbPrice.render(priceEl, price, parseInt(swatch.getAttribute('data-compare-at-price'), 10));
      updateRowAlignment(card.querySelector('.bsb-plpc__row'));
    }

    const img = card.querySelector('.bsb-plpc__img');
    if (img) {
      const src400 = swatch.getAttribute('data-img-400');
      const src600 = swatch.getAttribute('data-img-600');
      const src800 = swatch.getAttribute('data-img-800');
      const urls = [[400, src400], [600, src600], [800, src800]].filter(([, u]) => u);
      if (urls.length) {
        img.src = urls[urls.length - 1][1];
        img.srcset = urls.map(([w, u]) => `${u} ${w}w`).join(', ');
      }
    }
  });
})();
